/* DMØN — le seul JavaScript du thème.
   Pas de jQuery, pas de framework, pas de dépendance. Deux comportements, et
   les deux dégradent proprement : sans JS, le formulaire produit reste
   soumettable et la galerie reste consultable. */

(function () {
  "use strict";

  /* ── Sélecteur de variante ────────────────────────────────
     Les options sont de vrais <input type="radio"> dans le <form>. Sans JS,
     Shopify résout quand même la variante à la soumission. Avec JS, on met à
     jour l'identifiant, le prix et l'état du bouton sans recharger. */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var variants = JSON.parse(form.querySelector("[data-variants]").textContent);
    var idField = form.querySelector("[data-variant-id]");
    var submit = form.querySelector("[data-add]");
    var priceEl = document.querySelector("[data-price]");

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll("[data-option]:checked"), function (i) {
        return i.value;
      });
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length === values.length && v.options.every(function (o, n) { return o === values[n]; })) return v;
      }
      return null;
    }

    function refresh() {
      var variant = match(selected());

      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.getAttribute("data-unavailable");
        return;
      }

      idField.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available
        ? submit.getAttribute("data-add-label")
        : submit.getAttribute("data-sold-out");

      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url.toString());
      }
    }

    form.addEventListener("change", function (event) {
      if (event.target.matches("[data-option]")) refresh();
    });

    refresh();
  });

  /* ── Galerie produit ──────────────────────────────────────
     Les vignettes sont des <button>. Sans JS elles ne font rien de nuisible :
     toutes les images restent dans le DOM, empilées. */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main] img");
    if (!main) return;

    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var img = thumb.querySelector("img");
        main.src = thumb.getAttribute("data-src");
        main.srcset = thumb.getAttribute("data-srcset") || "";
        main.alt = img ? img.alt : "";
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.setAttribute("aria-current", t === thumb ? "true" : "false");
        });
      });
    });
  });
})();
